// all pages configs
const pages = [{
        pageID: 'index',
        instagram: 'neotix.consultoria',
        name: 'Thank you Me',
        camelName: 'thankYouMe',
        variableName: 'thank_you_me',
        address: 'Address Test',
        contact: '0800 600 8088',
        email: 'contato@thankyoume.com',
        urls: {
            instagram:'https://www.instagram.com/neotix.consultoria',
            facebook:'https://www.facebook.com/Neotixtransformacaodigital/',
            linkedin:"https://www.linkedin.com/company/neotix"
        },
        image_destino: "/images/menu/destinos/index.png",
        disabled: false
    },

]


const getOneById = function(pageID) {
    return pages.find((page) => page.pageID == pageID)
}
module.exports = {
    pages: pages,
    getOneById: getOneById
}
